import { render, staticRenderFns } from "./iframeMixin.vue?vue&type=template&id=35d27f44&scoped=true&"
import script from "./iframeMixin.vue?vue&type=script&lang=js&"
export * from "./iframeMixin.vue?vue&type=script&lang=js&"
import style0 from "./iframeMixin.vue?vue&type=style&index=0&id=35d27f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d27f44",
  null
  
)

export default component.exports